import React, { useEffect, useCallback, useState } from "react";
import InputContainer from "../../pages/citizen/TCPForms/layout/inputContainer";
import { farPayment } from "../../pages/citizen/TCPForms/data";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { OBPSService } from "../../../../../libraries/src/services/elements/OBPS";
// import { useFetchFarPaymentDetails } from "@egovernments/digit-ui-libraries/src/hooks/payment";

const FarPaymentOption = ({ tenantId, formData, setFetchedPaymentData }) => {
  console.log("formDatafromPayment", formData, tenantId);

  const { control, watch } = useForm();
  const selectedMode = watch("farPaymentOption");
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handlePaymentMode = (value) => {
    console.log(value, "valueFromCHange");

    if (value === "Full Payment") {
      console.log("handlePaymentFull");
      setPaymentMode("full");
    } else {
      console.log("handlePaymentInstallments");
      setPaymentMode("installments");
    }
  };
  const paymentPayload = {
    CalulationCriteria: [
      {
        FeeRequest: {
          fee: {
            tenantid: tenantId || "up",
            businessservice: formData?.businessService,
            consumercode: formData?.applicationNo,
            billno: "123",
          },
          fees: {
            totalfee: formData?.taxHeadEstimates?.[0]?.estimateAmount,
            paymentMode: paymentMode,
          },
        },
        tenantId: tenantId || "up",
        feeType: "ApplicationFee",
      },
    ],
  };

  const fetchPaymentDetails = async (paymentPayload) => {
    console.log("insideFetchFunction");
    try {
      const result = await OBPSService.calculateInstallments(paymentPayload);

      setFetchedPaymentData(result?.Calculations?.[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(async () => {
    if (paymentMode) {
      console.log("effectPaymentCalled", paymentMode);

      await fetchPaymentDetails(paymentPayload);
    }
  }, [paymentMode]);

  // const callPaymentApi = () => {
  //   const fetchPaymentDetails = async () => {
  //     if (!paymentMode) return;
  //     return await Digit.OBPSService.calculateInstallments(paymentPayload);
  //   };

  //   const { data: paymentData, isLoading: paymentLoading, isSuccess: isPaymentFetched } = useQuery("farPayment", fetchPaymentDetails, {
  //     enabled: !!paymentMode,
  //   });
  //   if (paymentData) {
  //     setFetchedPaymentData(paymentData);
  //   }
  // };
  // useEffect(() => {
  //   console.log("insidePaymentEffect");
  //   callPaymentApi();
  // }, [paymentMode]);

  return (
    <React.Fragment>
      <div onChange={(e) => handlePaymentMode(e.target.value)}>
        <InputContainer control={control} type="radioButton" name={"farPaymentOption"} data={farPayment} label={"Select Payment Mode"} />
      </div>
    </React.Fragment>
  );
};

export default FarPaymentOption;
